
import Vue from 'vue';
import { db } from "@/firebase";
import restCountriesMixin from "@/mixins/restCountriesMixin";

export default Vue.util.mergeOptions(restCountriesMixin, {
  methods: {
    async _getCorrectEventLanguages(customerID) {
        const languageTypes = (await db.ref(`customers/${customerID}/languageTypes`).once("value")).val();

        return Promise.all(languageTypes.map(async (countryCode, index) => {
          const {
            nativeName,
            countryFlag
          } = (await db.ref(`languages/${countryCode}`).once("value")).val();

          return {
            index,
            nativeName,
            countryCode,
            countryFlag
          }

        }))
    }
  }
});